/**
 * Shared list/query encoding for admin API modules.
 * Matches historical hand-rolled params: truthy page/pageSize, first sort key,
 * sortDesc[0] → 'desc'|'asc'. Domain-specific keys stay on the caller.
 */

export function appendListParams(params, page, pageSize, sortBy, sortDesc) {
  if (page) params['page'] = page;
  if (pageSize) params['paginate'] = pageSize;
  if (sortBy && sortBy.length) params['sort_by'] = sortBy[0];
  if (sortDesc && sortDesc.length) params['sort_order'] = ((sortDesc[0]) ? 'desc' : 'asc');
  return params;
}

export function toQuerySuffix(params) {
  let qs = (new URLSearchParams(params)).toString();
  if (qs.length) qs = '?' + qs;
  return qs;
}
